import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { /* Button, */ Form, Button as bsButton, FormGroup, Label, Input, FormText, Col, Row, InputGroup,
    InputGroupAddon,
    InputGroupButtonDropdown,
} from 'reactstrap';
import Card from '@material-ui/core/Card';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ChatIcon from '@material-ui/icons/Chat';
import './QuestionModal.css';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import AddBoxIcon from '@material-ui/icons/AddBox';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import SystemLabel from '../../../../../../system/SystemLabel/SystemLabel';
import { questionActions } from '../../../../../../store/actions/question/question.action';
import ReactDragList from "react-drag-list";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const defaultQuestion = {
    type: "Text",
    requiredMin: 0,
    requiredMax: 0,
    eventId: null,
    allowedAnswerCount: 1,
    label: '',
    languageCode: 'swe',
    options: []
}


function QuestionModal(props) {
    const [question, setQuestion] = React.useState(Object.assign({}, defaultQuestion))
    const [placeholderOption, newOption] = React.useState('');

    const { open, toggleModal, lang, user, onQuestionAdd } = props;
    const handleClose = () => {
    /*     setQuestion(Object.assign({}, defaultQuestion)); */
        toggleModal(false);
    };
    const sortOptions = (options) => {
        if (options.length === 0) return [];
        options.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
        })
        return options;
    }

    const createQuestion = () => {
        const cQuestion = Object.assign({}, question);
        if (cQuestion.type === 'Text') {
            cQuestion.options = [];
        }
        else {
            cQuestion.options.map(o => {
                delete o.id;
            })
        }
        cQuestion.sortOrder = props.sortOrder;
        cQuestion.languageCode = lang;
        cQuestion.eventId = props.eventId;
        const { dispatch } = props;
        dispatch(questionActions.createQuestion(cQuestion));
        setQuestion(Object.assign({}, defaultQuestion));
        toggleModal(false);
    }
    const onOptionLabelChange = (index, value) => {
        const uQuestion = Object.assign({}, question);
        const options = Array.from(uQuestion.options)
        options[index].text = value;
        uQuestion.options = options;
        setQuestion(uQuestion);
    }
    const addOption = () => {
        const name = placeholderOption;
        const { user } = props;
        const sortOrder = question.options.length > 0 ? question.options.length + 1 : 1;

        const option = {
            id: sortOrder,
            text: name,
            languageCode: lang,
            sortOrder
        };
        newOption('');

        const uOptions = Array.from(question.options);
        uOptions.push(option);
        handleChange(uOptions, 'options')

    }
    const handleOrderChange = (event, dataSource) => {
        const sortedOptions = dataSource.map((ds, i) => {
            let el = Object.assign({}, ds);
            el.sortOrder = i;
            return el;
        });
        /*         const uOptions = Array.from(question.options);
                uQuestion.options = sortedOptions */
        handleChange(sortedOptions, 'options')
    };

    const handleChange = (value, path) => {
        const uQuestion = Object.assign({}, question);
        uQuestion[path] = value;
        setQuestion(uQuestion);
    }
    const deleteOption = (index) => {
        const uOptions = Array.from(question.options);
        uOptions.splice(index, 1);
        handleChange(uOptions, 'options')
    }
    return (
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title"><SystemLabel name="AddQuestion" /></DialogTitle>
                <DialogContent style={{ minWidth: '450px' }}>
                    <FormGroup>
                        <Label for="questionName"><SystemLabel name="QuestionName" /></Label>
                        <Input type="text" name="name" value={question.name} onChange={(e) => handleChange(e.target.value, 'label')} id="questionName" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleEmail"><SystemLabel name="AllowedAnswerCount" /></Label>
                        <Input onChange={(e) => handleChange(e.target.value, 'allowedAnswerCount')} type="number" value={question.allowedAnswerCount} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="examplePassword"><SystemLabel name="QuestionType" /></Label>
                        <Row>
                            <Col>
                                <div onClick={() => handleChange('Text', 'type')} className={"checkbox-btn" + `${question.type === 'Text' ? ' curr' : ''}`} >
                                    <ChatIcon />
                                    <div><SystemLabel name="Text" /></div>
                                </div>
                            </Col>
                            <Col>
                                <div onClick={(e) => handleChange('Option', 'type')} className={"checkbox-btn" + `${question.type === 'Option' ? ' curr' : ''}`} >
                                    < CheckBoxIcon />
                                    <div><SystemLabel name="Option" /></div>
                                </div>
                            </Col>
                        </Row>
                    </FormGroup>

                    {question.type === 'Option' ? <FormGroup>
                        <Row form>
                            <Col /* md={6} */>
                                <FormGroup>
                                    <Label for="exampleEmail"><SystemLabel name="RequiredMin" /></Label>
                                    <Input onChange={(e) => handleChange(e.target.value, 'requiredMin')} type="number" value={question.requiredMin} />
                                </FormGroup>
                            </Col>
                            <Col /* md={6} */>
                                <FormGroup>
                                    <Label for="exampleEmail"><SystemLabel name="RequiredMax" /></Label>
                                    <Input onChange={(e) => handleChange(e.target.value, 'requiredMax')} type="number" value={question.requiredMax} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </FormGroup> : null}
                    {question.type === 'Option' ? <FormGroup>

                        <Label for="exampleAddress2"><SystemLabel name="Options" /></Label>
                        <InputGroup>
                            <Input value={placeholderOption} onChange={(e) => newOption(e.target.value)} />
                            <InputGroupAddon addonType="append"><Button onClick={addOption} ><AddIcon /></Button></InputGroupAddon>
                        </InputGroup>
                    </FormGroup>
                        : null}
                    {question.type === 'Option' ? <List dense={true} >
                        <ReactDragList
                            animation={10}
                            dataSource={sortOptions(question.options)}
                            rowKey={"id"}
                            /*               style={{ display: 'inline-flex', width: '100%' }} */
                            className="simple-drag"
                            rowClassName="simple-drag-row"
                            handles={false}
                            onUpdate={(event, dataSource) =>
                                handleOrderChange(event, dataSource)
                            }
                            row={(o, index) => {
                                return <Card key={index} style={{
                                    margin: '5px 0px',
                                    padding: ' 10px 0px',
                                    boxShadow: 'none',
                                    border: '1px solid gainsboro',
                                    display: undefined
                                }}>
                                    <ListItem>
                                        <Col className="col-1 text-left " style={{ marginRight: 20, marginLeft: -20 }}>
                                            <IconButton style={{ cursor: 'move' }}>
                                                <DragIndicatorIcon />
                                            </IconButton>
                                        </Col>
                                        <Col className="col-10 " style={{ margin: 0, }}>
                                            <Input
                                                onChange={(e) => onOptionLabelChange(index, e.target.value)}
                                                value={o.text || ''}
                                            />
                                        </Col>
                                        <Col className="col-1 text-right" style={{ marginLeft: 15 }}>
                                            <ListItemSecondaryAction>
                                                <IconButton edge="end"
                                                    onClick={() => deleteOption(index)} >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </Col>
                                    </ListItem>
                                </Card>
                            }}
                        />
                    </List> : null}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        <SystemLabel name="Cancel" />
                    </Button>
                    <Button onClick={createQuestion} color="primary">
                        <SystemLabel name="Create" />
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    return {
        user,
    };
}

export default connect(mapStateToProps)(QuestionModal);
